export default {
    'Back.link': "Back",
    "webSocketConnection": "[open] Connection established",
    "noDataFound": "No data found!",

    // REGISTRATIOLEFTSIDE 
    "mainTitleRegistrationLeftText":"The Only App That Lets Your Friends Call You Directly Without The Need For A Personal Phone Number",
    "freeCallList1Text":"Free User to User Calls.",
    "interNationalText":"International Access Numbers.",
    "cancelAnytimeText":"Cancel Anytime.",
    "yearRegistrationReserved":"© 2022 {name}. All rights reserved.",

       //SIGNUP
    "fristNameError":"First name is required",
    "lastNameError":"Last name is required",
    "emailError":"E-mail is required",
    "passwordError":"Password is required",
    "phoneNumber":"Please enter valid phone number",
    "termAndConditionError":"Please agree to the terms and conditions",
    "userAlreadyExist": "User already exist",
    "upperCasePasswordPolicyError":"Password should contain at least one uppercase letter",
    "lowerCasePasswordPolicyError":"Password should contain at least one lowercase letter",
    "passwordNumberPolicyError":"Password should contain at least one number",
    "password@PolicyError":"Password could not be contain '@'.",
    "passwordLengthPolicyError":"Password  minimum length should be 12",
    "appInfoMsg": "The Only App That Lets Your Friends Call You Directly Without The Need For A Personal Phone Number",
    "appInfoMsgForCall":"Free User to User Calls.",
    "appInfoMsgForInternationalAccessNumber":"International Access Numbers.",
    "appInfoMsgForCancel":"Cancel Anytime.",
    "appinfoMsgForRightsReserved":"© 2022 {name}. All rights reserved.",
    "appWelcomeMsg":"Welcome to {name}!",
    "appConectMsg1":"Easily connect with your friends",
    "appConectMsg2":"family and co-workers.",
    "loginPageLink":'Already have an account?',
    "termAndConditionLink1": 'I agree to the',
    "termAndConditionLink2": 'Terms & Conditions and Privacy Policy',


    //LOGIN
    "userNameAndPasswordError":"Please enter your E-mail and password",
    "passwordLogoForEyeOpen": "../eye-open.png",
    "passwordLogForEyeClose":"../close-eye.png",
    "emailLable":"E-mail",
    "paswordLable":"password",
    "loginButtonName":"Log In",
    "loginButtonName1":"Connecting...",


    //MAINCHAT
    "couponCodeIdea":"https://apps.elfsight.com/p/platform.js",
    

    //CHAT AND SIDEBAROPTION
    "personalChat":"personal",
    "search":"Search",
    "groupChat":"group",
    "groupListLable":"Groups",
    "groupProfileIcon":"#",
    "directMessagesListLable":"Direct Messages",
    "typingindicater":"{name} is typing ...",
    "buttonMsgSend":"SEND",
    "accept":"Accept",
    "remove":"remove",
    "join":"join",
    "leave":"leave",
    "timeout":"timeout",
    "interval":"interval",


    //Drawer
    "closeButton":"X",
    "drawerAvatar":"#",
    "manageAccount":"Manage your account",
    "logoutLink":"Logout",
    "groupMemberListMsg":"Group member's {name}",
    "profileUrlType":"assets/image/image 1.png",
    "profileUrlType1":"/assets/image/image 1.png",


    //HEADER
    "upgradePlan":"Upgrade Plan",
    "viewPlan":"View Plan",
    "appName":"{name}",
    "headerDrawerAvatar":"#",


    // GROUP
    "atleast1User": "At least 1 contact must be selected",
    "groupName": "Group Name",
    "participants": "Participants",
    "createGroupInputMessage": "Enter your group",
    "groupNameAlreadtExist": "Group name already exist!!!",
    "enterNewSubject": "Enter new subject",
    "addParticipants": "Add Participants",
    "alreadyInGroup": "Already added to the group",
    "groupMembers": "Group members",
    "leaveGroup": "Leave Group",
    "deleteGroup": "Delete Group",
    "createGroupSuccess": "Group created",
    "createGroupError": "Oops, Group not created",
    "editGroupSuccess": "Group name edited",
    "editGroupError": "Oops, Group name not edited",
    "inviteUserSuccess": "Users invited",
    "inviteUserError": "Oops, Users not invited",
    "removeUserSuccess": "User removed",
    "removeUserError": "Oops, User not removed",
    "leaveGroupSuccess": "Group leaved",
    "deleteGroupSuccess": "Group deleted",
    "deleteGroupError": "Oops, Group not deleted",


    //CHAT
    "isTyping": "{name} is typing...",
    "enterYourMessage": "Enter your message...",
    "chat": "Chat",
    "directMessage": "Direct Messages",
    "groups": "Groups",


    //CONTACTS
    "freindRequest": "Friend Requests",
    "sentRequest": "Sent Requests",
    "recievedRequest": "Received Requests",
    "search": "Search",
    "contacts": "Contacts",
    "searchPageHeader": "Add your contacts to IM and create groups",
    "searchPlaceholder": "Search Konnect",
    "searchResult": "Search Results",
    "sentFriendRequest" : "{name} sent you freind request",


    //NAVBAR
    "homeTab": "Home",
    "contactTab": "Contacts",
    "chatTab": "Chat",
    "settingsTab": "Settings",


    //PAYMENT
    "selectPlanError": "Please select any one plan",
    "couponIsNotValid": "Coupon not valid",
    "mustProvideAllDetalis": "Must provide all details",
    "paymentInfoPageChangePasswordLable":"Change Password",
    "EnterCouponCode":"Enter coupon code",
    "NextButtonInCoupon":"Next",
    "UpgradePlanLable":"Upgrade",
    "enterValidCardDetails": "Please enter valid card details",
    "enterValidCvv": "Please enter valid cvv details",
    "enterValidDate": "Please enter valid expiry date mm/yy",
    "viewPlanInAccountPage":"View Plan",
    "enterValidUserName": "Please enter your E-mail",
    "enterValidPassword": "Please enter your password",
    "passowordAndConfirmPasswordError": "Password and confirmPassword must be same",
    "imageSelectError": "Please select max 5mb image",
    "appHordingDetails": "1 Phone Number    Choose a local number in France, Germany, United States of America, United Kingdom, Canada, Visual Voice Mail Access Points",
    "accessPointsDetails": "Access points to recieve numbers from abroad",
    "paymentDetailsInfo":"Add your payment detail",
    "lableCardNumber":"Card Naumber",
    "lableExpireDate":"Expire Date",
    "placeHolderForExpireDate":"MM/YY",
    "lableCvv":"CVV",
    "placeHolderForCvv":"xxx",
    "paymentButton":"Pay",
    "billingDetailsInfo":"Add your billing address",
    "lableFristName":"First Name",
    "lableLastName":"Last Name",
    "lableAddressLine1":"Address Line 1",
    "lableAddressLine2":"Address Line 2",
    "lableAddressLine2Optional":"optional",
    "lableCity":"City",
    "lableZip":"Zip",
    "lableState":"State",
    "lableCountry":"Country",
    "biilingButton":"Next",
    "paymentInfoLableName":"Name:",
    "paymentInfoLableActivePlan":"Active Plan:",
    "paymentInfoLableEmail":"E-mail:",
    "paymentInfoLableBillingAddress":"Billing Address",
    "paymentInfoLableKonnectNumber":"Konnect Number:",
    "paymentInfoLablePhoneNumber":"Phone Number:",
    "currentPage":"Your current plan ",
    "currentPaymentInfo": "1 US or Canadian Phone Number",
    "currentPaymentInfo1": "Unlimited calls and SMS to US and Canada",
    "currentPaymentLableAccount": "Account",
    "currentPaymentLableBillingAddress": "Billing Address",
    "currentPaymentLableFirstName": "First Name : ",
    "currentPaymentLastName": "Last Name :",
    "currentPaymentLableCity": "City :",
    "currentPaymentLableState": "State :",
    "currentPaymentLableZip": "Zip :",
    "currentPaymentLableCountryCode": "Country Code :",
    "currentPaymentLableFullAddress": "Full Address:",


    //LOGIN
    "userConfirmError":"User is not confirmed.",
    "forgotPasswordLink":"Forgot your password?",
    "signupMsgLink":"Don't have an account?",
    "signupMsgLink1":"Sign up for free.",


    //CONFIRMOTP
    "userRegisterSuccessMsg": "You have successfully registered",


    //SIGNUP
    "fristNameError":"First name is required",
    "lastNameError":"Last name is required",
    "emailError":"E-mail is required",
    "passwordError":"Password is required",
    "phoneNumber":"Please enter valid phone number",
    "termAndConditionError":"Please agree to the terms and conditions",
    "userAlreadyExist": "User already exist",
    "upperCasePasswordPolicyError":"Password should contain at least one uppercase letter",
    "lowerCasePasswordPolicyError":"Password should contain at least one lowercase letter",
    "passwordNumberPolicyError":"Password should contain at least one number",
    "password@PolicyError":"Password could not be contain '@'.",
    "passwordLengthPolicyError":"Password  minimum length should be 12",
    "appInfoMsg": "The Only App That Lets Your Friends Call You Directly Without The Need For A Personal Phone Number",
    "appInfoMsgForCall":"Free User to User Calls.",
    "appInfoMsgForInternationalAccessNumber":"International Access Numbers.",
    "appInfoMsgForCancel":"Cancel Anytime.",
    "appinfoMsgForRightsReserved":"© 2022 {name}. All rights reserved.",
    "appWelcomeMsg":"Welcome to {name}!",
    "appConectMsg1":"Easily connect with your friends",
    "appConectMsg2":"family and co-workers.",
    "loginPageLink":'Already have an account?',
    "termAndConditionLink1": 'I agree to the',
    "termAndConditionLink2": 'Terms & Conditions and Privacy Policy',

    //SUCCESS MSG
    "sucessFullySelctNewPlanMsg":"You are successfully subscribed to the plan {name}",


    //Payment
    "UserAlertMsg":"Please do not refresh",

    "resetyourPassword":"Reset your password",
    "verifictionCode":"Verifiction code",
    "newPassword":"New password",
    "confirmPassword":"Confirm password",
    "resetPasswordButton":"Reset password",
    "signInPageLink":"Sign in",
    "verificationSetYourNumber":"Verification code sent to your phone number",


    //ChangePassword
    "changePasswordLable":"Change Password",
    "oldPasswordLable":"Password",
    "confirmPassword":"Confirm password",
    "newPasswordLable":"New Password",
    "changePasswordMsgError":"please enter old passworld and new password!"
};
  